const importEngine = {
  title: "Движок импорта",
  description: "Импорт файлов CSV/Excel в систему сущностей",
  uploadFile: "Загрузить файл",
  dragDrop: "Перетащите файл сюда",
  orClickBrowse: "или нажмите для выбора",
  supportedFormats: "Поддерживаемые форматы: CSV, XLSX, XLS",
  maxFileSize: "Макс. 5MB",
  maxRows: "Макс. 5,000 строк",
  selectEntityType: "Выберите тип сущности",
  columnMapping: "Сопоставление столбцов",
  autoDetect: "Авто-определение",
  autoDetectAll: "Авто-определение всех",
  sourceColumn: "Исходный столбец",
  targetField: "Целевое поле",
  detectedType: "Определённый тип",
  confidence: "Уверенность",
  skip: "Пропустить",
  preview: "Предпросмотр",
  previewDescription: "Показаны первые 10 строк",
  validRows: "валидных строк",
  invalidRows: "невалидных строк",
  skippedColumns: "пропущенных столбцов",
  errorRate: "Процент ошибок",
  errorRateWarning: "Процент ошибок слишком высок (макс. 10%)",
  importing: "Импорт",
  importComplete: "Импорт завершён",
  importFailed: "Импорт не удался",
  importProgress: "Прогресс",
  rowsImported: "строк импортировано",
  rowsFailed: "строк с ошибкой",
  errors: "Ошибки",
  back: "Назад",
  next: "Далее",
  startImport: "Начать импорт",
  importHistory: "История импорта",
  fileName: "Имя файла",
  entityType: "Тип сущности",
  date: "Дата",
  status: "Статус",
  statusPending: "Ожидание",
  statusProcessing: "Обработка",
  statusCompleted: "Завершён",
  statusFailed: "Ошибка",
  noImports: "Нет импортов",
  viewErrors: "Просмотр ошибок",
  downloadErrors: "Скачать ошибки",
} as const;
export default importEngine;
